import { useQuery } from "@tanstack/react-query"
import { api, type FeedPlacement } from "@/api"

export const feedKeys = {
  all: ["feed"] as const,
  list: (placement: FeedPlacement) => ["feed", placement] as const,
}

export function useFeedBlocks(placement: FeedPlacement) {
  return useQuery({
    queryKey: feedKeys.list(placement),
    queryFn: () => api.feed.list(placement),
  })
}
